import React, { useState } from "react";
import Lottie from "lottie-react";
import "./SubscribeForm.scss";

type SubscribeFormProps = {
  setOpenModal: (open: boolean) => void;
  onSignUp?: () => void;
};

const SubscribeForm: React.FC<SubscribeFormProps> = ({
  setOpenModal,
  onSignUp,
}) => {
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [lottieData, setLottieData] = useState<any>(null);
  const [securedFilesData, setSecuredFilesData] = useState<any>(null);

  React.useEffect(() => {
    const loadLottie = async () => {
      try {
        // Load the chat lottie JSON from public folder
        const response = await fetch("/lottie/Chat.json");
        if (!response.ok) {
          throw new Error(`Failed to load lottie: ${response.status}`);
        }
        const data = await response.json();
        setLottieData(data);
      } catch (err) {
        console.error("Error loading lottie:", err);
      }
    };
    loadLottie();
  }, []);

  React.useEffect(() => {
    const loadSecuredFiles = async () => {
      try {
        // Load the secured files lottie JSON from public folder
        const url = "/lottie/files.json";
        console.log("Loading files.json from:", url);
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(
            `Failed to load secured files lottie: ${response.status}`,
          );
        }
        const data = await response.json();
        console.log("Files lottie data loaded:", data);
        setSecuredFilesData(data);
      } catch (err) {
        console.error("Error loading secured files lottie:", err);
      }
    };
    loadSecuredFiles();
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const formData = {
      name,
      email,
      access_key: "ac480be8-2e35-4600-8a97-742b603782b3",
      subject: "Community subscription request",
    };

    fetch("https://api.web3forms.com/submit" as string, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(() => {
        localStorage.setItem("subPrev", "true");
        setEmail("");
        setName("");
        setOpenModal(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("There was an error processing your request.");
      });
  };

  return (
    <>
      <div className="subscribe-container">
        <div className="subscribe-header">
          <h1 className="frm-tit">Sign up to unlock features</h1>
        </div>

        <div className="benefits-badge">
          <span>Get instant access to premium features</span>
        </div>

        <div className="features-section">
          <div className="feature-item">
            <div className="feature-visual">
              <div className="file-animation">
                {securedFilesData && (
                  <Lottie
                    animationData={securedFilesData}
                    loop
                    autoplay
                    style={{ width: "100%", height: "100%" }}
                  />
                )}
              </div>
            </div>
            <div className="feature-text">
              <h4>View All Your Uploads</h4>
              <p>Keep track of all your scans and analysis history</p>
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-visual">
              <div className="chat-animation">
                {lottieData && (
                  <Lottie
                    animationData={lottieData}
                    loop
                    autoplay
                    style={{ width: "100%", height: "100%" }}
                  />
                )}
              </div>
            </div>
            <div className="feature-text">
              <h4>AI Chatbot Assistant</h4>
              <p>Get answers about your security analysis instantly</p>
            </div>
          </div>
        </div>

        <div className="cta-section">
          <button
            onClick={() => {
              localStorage.setItem("subPrev", "true");
              setOpenModal(false);
              if (onSignUp) {
                onSignUp();
              }
            }}
            className="signup-btn"
          >
            <span>Sign Up Free</span>
          </button>
          <p className="security-note">
            No credit card required • Instant access
          </p>
        </div>
      </div>
    </>
  );
};

export default SubscribeForm;
